import React from 'react';
import { Play, Headphones } from 'lucide-react';
import { useParallax } from '../hooks/useParallax';
const episodes = [{
  title: 'Nail It Then Scale It',
  description: 'Justin Ducharme joins to break down the tension between expertise and scalability, when to perfect your craft and when to grow.',
  youtubeUrl: 'https://www.youtube.com/watch?v=12Py6tIYamI',
  spotifyUrl: 'https://open.spotify.com/show/4IHMpSES2R4Zx4t0Et2oX8',
  image: 'https://cdn.magicpatterns.com/uploads/qtNj6iMqGZamqMTDgDKHAZ/nail-it-scale-it.png'
}, {
  title: 'Landscapers Are Ruining Your Home',
  description: 'Logan Maine of Love Outdoor Lighting reveals what it really takes to run a high-ticket outdoor lighting design company without a massive team.',
  youtubeUrl: 'https://www.youtube.com/watch?v=W2J10lck4Nw',
  spotifyUrl: 'https://open.spotify.com/show/4IHMpSES2R4Zx4t0Et2oX8',
  image: 'https://cdn.magicpatterns.com/uploads/tYXURjXuSCbyQJSKgf6JQq/landscapers-are-ruining-your-home.png'
}, {
  title: 'Marine to Drone Mogul',
  description: 'Meet John Peel of Busy Drones Cleaners and hear his success story of building a drone cleaning business from scratch after serving in the Marines.',
  youtubeUrl: 'https://www.youtube.com/watch?v=Y76L4he6MlQ',
  spotifyUrl: 'https://open.spotify.com/show/4IHMpSES2R4Zx4t0Et2oX8',
  image: 'https://cdn.magicpatterns.com/uploads/1aJ9bfdUpbsaJ6zABx1iHS/marine-to-drone-mogul.png'
}, {
  title: 'Building My Cleaning Empire',
  description: "Andy Benedeck of Blue Cactus Power Washing shares how he started at 16 and built a half-million dollar business, starting from zero so you don't have to.",
  youtubeUrl: 'https://www.youtube.com/watch?v=sI8A8PwidMA',
  spotifyUrl: 'https://open.spotify.com/show/4IHMpSES2R4Zx4t0Et2oX8',
  image: 'https://cdn.magicpatterns.com/uploads/8Eig6fJKc16ogCks6zUZaz/building-my-cleaning-empire.png'
}, {
  title: 'Business Practices to Avoid',
  description: 'Josh Henderson of Squatch Garage Doors talks his winding journey from blue collar to real estate and back, and the business mistakes worth skipping.',
  youtubeUrl: 'https://www.youtube.com/watch?v=KoGAPzyqzAA',
  spotifyUrl: 'https://open.spotify.com/show/4IHMpSES2R4Zx4t0Et2oX8',
  image: 'https://cdn.magicpatterns.com/uploads/rcMEpjuFV8B4ZLvatV8K6c/businesses-practices-to-avoid.png'
}];
function EpisodeCard({
  episode
}: {
  episode: (typeof episodes)[0];
}) {
  const {
    ref,
    style
  } = useParallax(0.1);
  return <div className="flex flex-col md:flex-row gap-6 md:gap-8 mb-12 last:mb-0" data-id="element-122">
      {/* Thumbnail */}
      <div ref={ref} className="w-full md:w-[45%] aspect-video overflow-hidden rounded-lg flex-shrink-0" data-id="element-123">
        <img src={episode.image} alt={episode.title} className="w-full h-full object-cover" style={style} data-id="element-124" />
      </div>

      {/* Content */}
      <div className="flex-1 flex flex-col justify-center" data-id="element-125">
        <h3 className="text-eofa-white font-heading font-black text-[28px] md:text-[32px] leading-[1.1] tracking-tight mb-4" data-id="element-126">
          {episode.title}
        </h3>
        <p className="text-eofa-body text-base md:text-lg max-w-[600px] mb-6 leading-relaxed" data-id="element-127">
          {episode.description}
        </p>

        {/* Platform Buttons */}
        <div className="flex flex-wrap gap-3" data-id="element-128">
          <a href={episode.youtubeUrl} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-eofa-yellow text-eofa-black font-bold rounded-md px-5 min-h-[44px] hover:bg-yellow-400 transition-colors text-sm" data-id="element-129">
            <Play size={16} className="fill-current" data-id="element-130" />
            Watch on YouTube
          </a>
          <a href={episode.spotifyUrl} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-transparent border border-eofa-white text-eofa-white font-bold rounded-md px-5 min-h-[44px] hover:bg-eofa-white hover:text-eofa-black transition-colors text-sm" data-id="element-131">
            <Headphones size={16} data-id="element-132" />
            Listen on Spotify
          </a>
        </div>
      </div>
    </div>;
}
export function PopularEpisodes() {
  return <section className="bg-eofa-dark py-20 md:py-32" data-id="element-133">
      <div className="container mx-auto px-6" data-id="element-134">
        <h2 className="text-eofa-white font-heading font-black text-[32px] md:text-[48px] leading-[1.1] tracking-tighter mb-16" data-id="element-135">
          Most Popular Episodes
        </h2>

        <div data-id="element-136">
          {episodes.map(episode => <EpisodeCard key={episode.title} episode={episode} data-id="element-137" />)}
        </div>
      </div>
    </section>;
}